import { ExtendedTab, ExtendedTabProps } from "../ExtendedTab";
export const Tab = ExtendedTab;
export interface TabProps extends ExtendedTabProps {}
